<div class="flex w-full justify-end">
  <aw-language-switcher [formControl]="language" id="language-switcher">
  </aw-language-switcher>
</div>
@if (isLoading() || !customTileSectionForms) {
  <aw-loading-animation></aw-loading-animation>
} @else {
  <aw-section testIdAffix="start-page">
    <aw-section-header>
      <aw-section-headline>
        {{ cmsTextProvider.shared.startPage }}
      </aw-section-headline>
      <aw-section-header-actions>
        <aw-button
          (click)="save()"
          [isDisabled]="
            !customTileSectionForms.valid || !customTileSectionForms.dirty
          "
          [style]="'primary'"
          id="save"
          type="submit"
          >{{ cmsTextProvider.shared.save }}
        </aw-button>
        <aw-button
          [style]="'primary-alt'"
          class="ml-2"
          id="cancel"
          type="submit"
          >{{ cmsTextProvider.shared.cancel }}
        </aw-button>
      </aw-section-header-actions>
    </aw-section-header>

    <aw-section testIdAffix="sections">
      <aw-section-header>
        <aw-section-headline>
          {{ cmsTextProvider.shared.section }}
        </aw-section-headline>
        <aw-section-header-actions>
          <aw-button
            (click)="addNewSection()"
            [style]="'primary'"
            [text]="cmsTextProvider.shared.newSection"
            id="add-new-section"
            type="submit">
            <span class="material-symbols-rounded pr-2">add</span>
          </aw-button>
        </aw-section-header-actions>
      </aw-section-header>
      @for (sectionForm of customTileSectionForms.controls; track sectionForm) {
        <aw-start-page-section-block
          [id]="'section-' + $index"
          [sectionIndex]="$index"
          [lastIndex]="customTileSectionForms.controls.length - 1"
          [startPageSectionForm]="sectionForm"
          (moveSections)="moveItemAtIndex($event.oldIndex, $event.newIndex)"
          (atDeleteSection)="deleteSection($index, $event)">
        </aw-start-page-section-block>
      }
    </aw-section>
  </aw-section>
}
